import { render } from "./updated.vue?vue&type=template&id=46fb1abf&lang=pug"
import script from "./updated.vue?vue&type=script&lang=js"
export * from "./updated.vue?vue&type=script&lang=js"

import "./updated.vue?vue&type=style&index=0&id=46fb1abf&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__